var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectPalette(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60203 7.68135C7.53686 8.15854 7.56967 8.64493 7.69825 9.10755C7.82682 9.57017 8.04815 9.99819 8.34722 10.3626C8.64629 10.727 9.0161 11.0192 9.43158 11.2195C9.84705 11.4197 10.2985 11.5233 10.7552 11.5232L13.4579 11.5232C14.293 11.5079 15.0889 11.147 15.6743 10.5182C16.2598 9.88948 16.5878 9.04317 16.5878 8.16159C16.5878 7.28001 16.2598 6.4337 15.6743 5.80494C15.0889 5.17617 14.293 4.81527 13.4579 4.79995L11.9129 4.79519",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3048 8.63255C10.37 8.15537 10.3372 7.66898 10.2086 7.20636C10.08 6.74374 9.8587 6.31572 9.55963 5.95133C9.26056 5.58694 8.89075 5.29471 8.47527 5.09445C8.0598 4.89419 7.60838 4.79059 7.15164 4.79068L4.44891 4.79068C3.61386 4.806 2.81791 5.16691 2.23251 5.79567C1.6471 6.42443 1.31907 7.27074 1.31907 8.15232C1.31907 9.0339 1.6471 9.88021 2.23251 10.509C2.81791 11.1377 3.61386 11.4986 4.44891 11.514L5.98947 11.514",
    stroke: "#7B7986",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectPalette);
export default __webpack_public_path__ + "static/media/selectPalette.ac6bec4fcbd79cd96c5df64caaab1917.svg";
export { ForwardRef as ReactComponent };